import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const CompanyComparisonChart = ({ data }) => {
  return (
    <div className="bg-card rounded-lg p-6 shadow-brand">
      <h3 className="text-lg font-semibold text-foreground mb-4">Company Performance Comparison</h3>
      <div className="w-full h-80" aria-label="Company Performance Comparison Chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis dataKey="month" stroke="#6B7280" />
            <YAxis stroke="#6B7280" />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: '#FFFFFF', 
                border: '1px solid #E5E7EB',
                borderRadius: '0.5rem'
              }}
            />
            <Legend />
            <Line 
              type="monotone" 
              dataKey="eppme" 
              stroke="#3B82F6" 
              strokeWidth={2}
              name="Eppme Digital"
              dot={{ fill: '#3B82F6', r: 4 }}
            />
            <Line 
              type="monotone" 
              dataKey="zetavista" 
              stroke="#8B5CF6" 
              strokeWidth={2}
              name="Zetavista Analytics"
              dot={{ fill: '#8B5CF6', r: 4 }}
            />
            <Line 
              type="monotone" 
              dataKey="degrey" 
              stroke="#10B981" 
              strokeWidth={2}
              name="DeGrey Digital"
              dot={{ fill: '#10B981', r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CompanyComparisonChart;